import { createSlice, current, type PayloadAction } from '@reduxjs/toolkit';

interface ProductoAttributes {
  precioFinal?: number;
  [key: string]: unknown;
}

interface Producto {
  id: number;
  attributes: ProductoAttributes;
}

interface FavoritosState {
  notas: unknown[];
  productos: Producto[];
}

const initialState: FavoritosState = {
  notas: [],
  productos: []
};

export const favoritosSlice = createSlice({
  name: 'favoritos',
  initialState,
  reducers: {
    notas: (state, action: PayloadAction<unknown>) => {
      let filtered = (current(state.notas)).filter(e=>e == action.payload);
      let newState;
      if(filtered.length == 0){
        newState = [...state.notas, action.payload];
      }else{
        newState = (current(state.notas)).filter(e=>e !== action.payload);
      }
      state.notas = newState;
    },
    productos: (state, action: PayloadAction<Producto>) => {
      let yaExiste = (current(state.productos)).some(e => e.id === action.payload.id);
      let newState;
      if(!yaExiste){
        newState = [...state.productos, action.payload];
      }else{
        newState = (current(state.productos)).filter(e => e.id !== action.payload.id);
      }
      state.productos = newState;
    },
    vaciarFavoritos: (state) => {
      state.notas = [];
      state.productos = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  notas,
  productos,
} = favoritosSlice.actions;

export default favoritosSlice.reducer;
